// extracted by mini-css-extract-plugin
export default {"policy_warning":"styles_policy_warning__UqPMr","align__left":"styles_align__left__bjBuT","align__center":"styles_align__center__bZD+j","align__right":"styles_align__right__M+9B1"};